export default "__VITE_ASSET__DNjgQ4p6__"